import React from 'react';
import { CHART, formatMeasure } from '../../utils/statsFormat';

/**
 * Classement en barres horizontales : une seule teinte, la longueur porte la grandeur.
 * @param {string} title
 * @param {Array} rows - [{ label, ...mesures }]
 * @param {Object} measure - { key, label, unit }
 * @param {Function} [formatLabel]
 * @param {Function} [onSelect] - Clic sur une ligne : filtre sur cette valeur
 */
const RankBars = ({ title, rows, measure, formatLabel = (v) => v, onSelect }) => {
  const shown = rows.filter((r) => r[measure.key] !== null && r[measure.key] !== undefined);
  const max = Math.max(...shown.map((r) => r[measure.key]), 0);

  return (
    <section className="rounded-lg border border-gray-200 bg-white p-4">
      <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
      <p className="mb-3 text-xs text-gray-500">{measure.label}{measure.unit ? ` (${measure.unit})` : ''}</p>
      {shown.length === 0 ? (
        <p className="py-6 text-center text-sm text-gray-400">Aucune donnée sur cette période</p>
      ) : (
        <ol className="space-y-2">
          {shown.map((row) => {
            const Row = onSelect ? 'button' : 'div';
            return (
              <li key={row.label}>
                <Row
                  {...(onSelect && { type: 'button', onClick: () => onSelect(row.label), title: `Filtrer sur ${formatLabel(row.label)}` })}
                  className={`block w-full text-left ${onSelect ? 'rounded hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500' : ''}`}
                >
                  <div className="flex items-baseline justify-between gap-3 text-sm">
                    <span className="truncate text-gray-800" title={formatLabel(row.label)}>{formatLabel(row.label)}</span>
                    <span className="flex-shrink-0 font-medium text-gray-900 tabular-nums">
                      {formatMeasure(row[measure.key], measure.unit)}
                    </span>
                  </div>
                  <div className="mt-1 h-2 rounded-full" style={{ backgroundColor: CHART.track }}>
                    <div
                      className="h-2 rounded-full"
                      style={{ width: `${max ? Math.max(1, (row[measure.key] / max) * 100) : 0}%`, backgroundColor: CHART.series }}
                    />
                  </div>
                </Row>
              </li>
            );
          })}
        </ol>
      )}
    </section>
  );
};

export default RankBars;
